import { ConcreteEncodable } from "./ConcreteEncodable";

import { BlotterFilterImplEncoder } from "../../encoder/BlotterFilterImplEncoder";

import * as CubiqTS from "../../index";
import { BlotterFilter } from "../BlotterFilter";

export class BlotterFilterImpl extends ConcreteEncodable implements BlotterFilter {
  public static enType: string = "com.bcdfx.model.BlotterFilterImpl";

  /*FID=1*/
  public filterId: CubiqTS.Long | null = null;
  /*FID=2*/
  public filterName: string;
  /*FID=3*/
  public entryUserId: CubiqTS.Long | null = null;
  /*FID=4*/
  public creationDts: CubiqTS.moment.Moment | null = null;
  /*FID=5*/
  public blotterType: CubiqTS.BlotterType;
  /*FID=6*/
  public queryGroup: CubiqTS.QueryGroup | null = null;
  /*FID=7*/
  public isSystemFilter: boolean;
  /*FID=8*/
  public assetClass: CubiqTS.AssetClass;
  /*FID=9*/
  public lastUpdateDts: CubiqTS.moment.Moment | null = null;
  /*FID=10*/
  public userType: CubiqTS.UserType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BlotterFilterImplEncoder.Instance;
    this.setEncodableType(BlotterFilterImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BlotterFilterImpl[" +
      "filterId=" +
      this.filterId +
      "filterName=" +
      this.filterName +
      "entryUserId=" +
      this.entryUserId +
      "creationDts=" +
      this.creationDts +
      "blotterType=" +
      this.blotterType +
      "queryGroup=" +
      this.queryGroup +
      "isSystemFilter=" +
      this.isSystemFilter +
      "assetClass=" +
      this.assetClass +
      "lastUpdateDts=" +
      this.lastUpdateDts +
      "userType=" +
      this.userType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
